import { createAction, props } from '@ngrx/store';
import { SchoolActivityInstance } from '../../../models';
import { BulkSignUpForActivityReq, SchoolActivityAttendee, SignUpForActivityReq } from '../../../services/school-activity.service';

export const GetAttendeesForInstanceAction = createAction(
	'[SchoolActivityAttendees] GetAttendeesForInstance',
	props<{ attendees: SchoolActivityAttendee[] }>()
);

export const RemoveAttendeeAndSignUpAction = createAction(
	'[SchoolActivityAttendees] RemoveAttendeeAndSignUpAction',
	props<{ attendeeId: number; req?: SignUpForActivityReq; instance?: SchoolActivityInstance }>()
);

export const RemoveAttendeeAndSignUpActionSuccess = createAction(
	'[SchoolActivityAttendees] RemoveAttendeeAndSignUpAction Success',
	props<{ attendeeId: number }>()
);

export const RemoveAttendeeAndSignUpActionFailure = createAction(
	'[SchoolActivityAttendees] RemoveAttendeeAndSignUpAction Failure',
	props<{ error: string }>()
);

export const BulkRemoveAttendeeAndSignUpAction = createAction(
	'[SchoolActivityAttendees] BulkRemoveAttendeeAndSignUpAction',
	props<{ attendeeIds: number[]; req: BulkSignUpForActivityReq; instance: SchoolActivityInstance; checkIn: boolean }>()
);
export const BulkRemoveAttendeeAndSignUpActionSuccess = createAction('[SchoolActivityAttendees] BulkRemoveAttendeeAndSignUpAction');

export const BulkRemoveAttendeeAndSignUpActionFailure = createAction(
	'[SchoolActivityAttendees] BulkRemoveAttendeeAndSignUpAction Failure',
	props<{ error: string }>()
);

export const SignUpForActivityAction = createAction(
	'[SchoolActivityAttendees] SignUpForActivity',
	props<{ req: SignUpForActivityReq; instance: SchoolActivityInstance }>()
);

export const SignUpForActivitySuccessAction = createAction(
	'[SchoolActivityAttendees] SignUpForActivity Success',
	props<{ attendee: SchoolActivityAttendee }>()
);

export const SignUpForActivityFailureAction = createAction('[SchoolActivityAttendees] SignUpForActivity Failure', props<{ error: string }>());

export const BulkSignUpForActivityAction = createAction(
	'[SchoolActivityAttendees] BulkSignUpForActivity',
	props<{ req: BulkSignUpForActivityReq; instance: SchoolActivityInstance; checkIn: boolean }>()
);

export const BulkSignUpForActivitySuccessAction = createAction(
	'[SchoolActivityAttendees] BulkSignUpForActivity Sucess',
	props<{ attendees: SchoolActivityAttendee[] }>()
);

export const BulkSignUpForActivityFailureAction = createAction('[SchoolActivityAttendees] BulkSignUpForActivity Failure', props<{ error: string }>());

export const BulkSignOutForActivityAction = createAction('[SchoolActivityAttendees] BulkSignOutForActivity', props<{ attendeeIds: number[] }>());

export const BulkSignOutForActivitySuccessAction = createAction(
	'[SchoolActivityAttendees] BulkSignOutForActivity Sucess',
	props<{ attendeeIds: number[] }>()
);

export const BulkSignOutForActivityFailureAction = createAction(
	'[SchoolActivityAttendees] BulkSignOutForActivity Failure',
	props<{ error: string }>()
);
